/**
 * Vue I18n 配置
 * 支援繁體中文 (zh-TW) 和英文 (en-US)
 */

import { createI18n } from 'vue-i18n'
import zhTW from './locales/zh-TW'
import enUS from './locales/en-US'

// 從 localStorage 獲取或使用預設語言
const getDefaultLocale = (): string => {
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && ['zh-TW', 'en-US'].includes(savedLocale)) {
    return savedLocale
  }

  // 自動偵測瀏覽器語言
  const browserLang = navigator.language
  if (browserLang.startsWith('zh')) {
    return 'zh-TW'
  }
  return 'en-US'
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-TW',
  messages: {
    'zh-TW': zhTW,
    'en-US': enUS,
  },
  globalInjection: true, // 全局注入 $t
})

/**
 * 切換語言
 * @param locale 語言代碼 ('zh-TW' | 'en-US')
 */
export function setLocale(locale: string) {
  if (i18n.global.availableLocales.includes(locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    document.documentElement.lang = locale
  }
}

/**
 * 獲取當前語言
 */
export function getCurrentLocale(): string {
  return i18n.global.locale.value
}

/**
 * 獲取可用語言列表
 */
export function getAvailableLocales() {
  return [
    { code: 'zh-TW', name: '繁體中文', nativeName: '繁體中文' },
    { code: 'en-US', name: 'English', nativeName: 'English (US)' },
  ]
}

export default i18n
